import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { authApi } from '@@/services/auth';

const initialState = {
  accessToken: '',
  expiresIn: 0,
  expiresAt: Date.now(),
  refreshToken: '',
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout() {
      return initialState;
    },
    refresh(state, { payload }) {
      return {
        ...state,
        accessToken: payload.access_token,
        refreshToken: payload.refresh_token,
        expiresIn: payload.expires_in,
        expiresAt: Date.now() + payload.expires_in * 1000,
      };
    },
    // Token injecté par l'application parente en mode embed. Pas de refresh
    // token : à expiration, le parent en réinjecte un neuf via postMessage.
    setEmbedToken(state, { payload }) {
      return {
        ...state,
        accessToken: payload.accessToken,
        refreshToken: '',
        expiresIn: payload.expiresIn,
        expiresAt: Date.now() + payload.expiresIn * 1000,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = initialState;
    });
    builder.addMatcher(
      authApi.endpoints.login.matchFulfilled,
      (state, { payload }) => {
        state.accessToken = payload.access_token;
        state.refreshToken = payload.refresh_token;
        state.expiresIn = payload.expires_in;
        state.expiresAt = Date.now() + state.expiresIn * 1000;
      },
    );
    builder.addMatcher(authApi.endpoints.logout.matchFulfilled, () => {
      return initialState;
    });
  },
});

export const { setEmbedToken } = slice.actions;

export default slice;
